import { useTranslation } from "react-i18next";

export const ChatbotThinkingBubble = () => {
	const { t } = useTranslation();

	return (
		<div className="chatbot-message-row">
			<div className="chatbot-bubble chatbot-bubble--bot chatbot-thinking-bubble">
				<span className="chatbot-thinking-dots">
					<span className="chatbot-thinking-dot" />
					<span className="chatbot-thinking-dot" />
					<span className="chatbot-thinking-dot" />
				</span>
				{t("globalChatbot.thinking", "Analizuję pytanie...")}
			</div>
		</div>
	);
};
